document.addEventListener("DOMContentLoaded", function () {
  if (window.innerWidth >= 1000) {

    // Animation - toRight
    const left_arm = document.querySelectorAll('.left_arm');
    const observerLeft = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        entry.target.style.animation = entry.intersectionRatio > 0
          ? 'left_arm .8s forwards ease-out'
          : 'none';
      });
    });
    left_arm.forEach(left => {
      observerLeft.observe(left);
    });

    // Animation - toLeft
    const right_arm = document.querySelectorAll('.right_arm');
    const observerRight = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        entry.target.style.animation = entry.intersectionRatio > 0
          ? 'right_arm .8s forwards ease-out'
          : 'none';
      });
    });
    right_arm.forEach(right => {
      observerRight.observe(right);
    });

    // Animation - toBottom
    const bottom_arm = document.querySelectorAll('.bottom_arm');
    const observerBottom = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        entry.target.style.animation = entry.intersectionRatio > 0
          ? 'bottom_arm .8s forwards ease-out'
          : 'none';
      });
    });
    bottom_arm.forEach(bottom => {
      observerBottom.observe(bottom);
    });

    // Animation - toTop
    const top_arm = document.querySelectorAll('.top_arm');
    const observerTop = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        entry.target.style.animation = entry.intersectionRatio > 0
          ? 'top_arm .8s forwards ease-out'
          : 'none';
      });
    });
    top_arm.forEach(top => {
      observerTop.observe(top);
    });

  }
});
